<template>
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            width="40"
            height="40"
            rx="11.25"
            fill="#43E3FF"
            fill-opacity="0.15"
        />
        <path
            d="M20.0001 7.82432C20.3722 8.11366 21.5561 9.0001 23.173 9.88229C25.0183 10.8891 27.5513 11.9594 30.1389 12.0241V21.0535C30.1389 23.9766 29.1599 26.1873 27.4515 27.9482C25.7208 29.7322 23.1884 31.107 20 32.2114C17.7039 31.4167 15.1622 30.3157 13.1969 28.5712C11.2559 26.8481 9.86111 24.4871 9.86111 21.0535V12.0242C12.4545 11.9596 14.9875 10.8894 16.832 9.88222C18.4468 9.00045 19.6279 8.1144 20.0001 7.82432ZM20.0516 32.2292C20.0522 32.2295 20.0529 32.2297 20.0535 32.2299L20.0534 32.2299C20.0528 32.2297 20.0522 32.2295 20.0516 32.2292Z"
            fill="#1D4E58"
            stroke="#48E4FF"
            stroke-width="2.22222"
        />
        <path
            d="M23.3838 19.3989L19.6338 23.1488C19.3898 23.3929 19.0699 23.515 18.75 23.515C18.43 23.515 18.1101 23.393 17.8661 23.1488L16.6161 21.8989C16.128 21.4107 16.128 20.6193 16.6161 20.1311C17.1042 19.643 17.8957 19.643 18.3839 20.1311L18.75 20.4972L21.6162 17.6311C22.1043 17.143 22.8958 17.143 23.384 17.6311C23.872 18.1193 23.872 18.9107 23.3838 19.3989Z"
            fill="#48E4FF"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
